export const formatEmailDate = (iso) =>
  new Date(iso).toLocaleString("fr-FR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });

export const OFFER_LABELS = {
  site_starter_once: "Site Starter",
  site_pro_once: "Site Pro",
  site_premium_once: "Site Premium",
  maintenance_monthly: "Maintenance continue (ancienne offre)",
  option_hosting_once: "Option Hébergement 1 an (ancienne offre)",
  hosting_yearly: "Hébergement seul — annuel",
  care_monthly: "Maintenance + Hébergement — mensuel",
  care_setup_once: "Maintenance + Hébergement (ancienne formule)",
  care_yearly: "Maintenance + Hébergement — annuel",
  option_logo_once: "Option Logo (retirée)",
  option_design_once: "Option Design (retirée)",
};

export const LEAD_STATUSES = [
  { value: "nouvelle", label: "Nouvelle", cls: "bg-gold/15 text-gold-dark" },
  { value: "contactee", label: "Contactée", cls: "bg-sky-100 text-sky-800" },
  { value: "devis_envoye", label: "Devis envoyé", cls: "bg-violet-100 text-violet-800" },
  { value: "signee", label: "Signée", cls: "bg-emerald-100 text-emerald-800" },
  { value: "en_construction", label: "Site en construction", cls: "bg-amber-100 text-amber-800" },
  { value: "publie", label: "Site publié", cls: "bg-navy text-gold" },
  { value: "perdue", label: "Perdue", cls: "bg-slate-100 text-slate-500" },
];

export const euro = (cents, currency = "eur") =>
  `${((cents || 0) / 100).toFixed(2).replace(".", ",")} ${(currency || "eur").toUpperCase()}`;

export const PAYMENT_STATUS_LABELS = {
  paid: "Payé",
  refunded: "Remboursé",
  failed: "Échoué",
  expired: "Expiré",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const EMPTY_BOX =
  "rounded-3xl border border-dashed border-navy/15 bg-white px-6 py-10 text-center text-sm text-slate-500";
export const ALERT_BOX = "rounded-2xl border border-gold/40 bg-gold/10 px-5 py-4 text-sm font-medium text-navy";
